module.exports = __webpack_public_path__ + "img/4.b7b8f1cc.webp";